import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=1a0b0ae6&scoped=true&"
import script from "./risk.vue?vue&type=script&lang=js&"
export * from "./risk.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/bootstrap.css?vue&type=style&index=0&id=1a0b0ae6&scoped=true&lang=css&"
import style1 from "./risk.vue?vue&type=style&index=1&id=1a0b0ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b0ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
